export const quickSearchFields = 'Title;Authors;Abstract'
